import {db} from '../firebase';
import {Logger} from '../plugins/logger';

const log = Logger.get('user');

export default {
  namespaced: true,
  state: {
    doc: {},
    linked: {}
  },
  mutations: {
    setDoc(state, doc) {
      state.doc = doc ? doc : {};
    },
    setLinked(state, linked) {
      state.linked = linked ? linked : {};
    }
  },
  getters: {
    linkedWith(state) {
      return state.doc.linkWith;
    },
    linkedTo(state) {
      return state.doc.linkTo;
    },
    linkedVerified(state, getters, rootState, rootGetters) {
      return state.linked.linkWith === rootGetters['auth/email'];
    },
    hasLink(state, getters) {
      return getters.linkedWith || getters.linkedTo;
    }
  },
  actions: {
    getUserDoc({commit, rootGetters}) {
      const email = rootGetters['auth/email'];
      const userDoc = `users/${email}`;
      log.debug('getUserDoc', userDoc);

      return db.doc(userDoc).get()
          .then(user => commit('setDoc', user.data()));
    },
    updateUserDoc({dispatch, rootGetters}, data) {
      const email = rootGetters['auth/email'];
      const userDoc = `users/${email}`;
      log.debug('updateUserDoc', userDoc, data);

      return db.doc(userDoc).set(data)
          .then(() => dispatch('getUserDoc'));
    },
    clearLink({commit, dispatch, rootGetters}) {
      const email = rootGetters['auth/email'];
      const userDoc = `users/${email}`;
      log.debug('clearLink', userDoc);

      return db.doc(userDoc).set({})
          .then(() => dispatch('getUserDoc'))
          .then(() => commit('setLinked', {}));
    },
    getLinkedUserDoc({commit, getters}) {
      const linkedTo = getters.linkedTo;
      const userDoc = `users/${linkedTo}`;
      log.debug('getLinkedUserDoc', userDoc);

      return db.doc(userDoc).get()
          .then(user => commit('setLinked', user.data()))
          .catch(err => {
            log.error('getLinkedUserDoc', err);
            // if we can't read the user doc, it's not verified
            commit('setLinked', {})
          });
    }
  }
}
